import type { SnippetCategory } from "routes/SnippetsPage/categories";
import { SnippetCard } from "routes/SnippetsPage/components/SnippetCard";
import type { SnippetDefinition } from "routes/SnippetsPage/registry";

type SnippetSectionProps = {
  category: SnippetCategory;
  snippets: SnippetDefinition[];
};

/**
 * カテゴリ見出し＋配下スニペット一覧を表示する。
 * @param {SnippetSectionProps} props カテゴリとスニペット配列
 * @return {JSX.Element} セクション
 */
export const SnippetSection = ({
  category,
  snippets,
}: SnippetSectionProps): JSX.Element => {
  return (
    <section id={`section-${category.key}`} className="scroll-mt-24 space-y-4">
      <header>
        <h2 className="text-xl font-bold">{category.label}</h2>
        <p className="text-sm text-base-content/60">{category.description}</p>
      </header>
      {snippets.length === 0 ? (
        <p className="text-sm text-base-content/50">
          このカテゴリにはまだスニペットがありません。
        </p>
      ) : (
        <div className="grid gap-4">
          {snippets.map(snippet => (
            <SnippetCard key={snippet.id} snippet={snippet} />
          ))}
        </div>
      )}
    </section>
  );
};
